import adminHttp from "@/api/adminHttp";

const END_POINT = '/api/v1/admin';
const NEW_END_POINT = '/api/v1/client';

export default {
    index: (params = {}) => {
        const {division, ...rest} = params;
        const url = NEW_END_POINT + `/mlbb-team-rating` + (division ? `/${division}` : '');
        return adminHttp.get(url, {params: rest});
    },

    actualize: () => adminHttp.get(END_POINT + `/actualize-mlbb-team-rating`),
    actualizedTime: () => adminHttp.get(NEW_END_POINT + `/rating-actualize-datetime`),
}